export const WEB_SERVICE_ROLE_ID = "cFKHnQdYU9T57j5AFytp";

export function useIsWebServiceRole() {
  const isWebServiceRole =
    localStorage.getItem("userRoleId") === WEB_SERVICE_ROLE_ID;

  return {
    isWebServiceRole,
    canEdit: !isWebServiceRole,
    isDisabled: isWebServiceRole,
  };
}

export default useIsWebServiceRole;
